import type { ComplexCollection } from 'bundles/browse-common/types/complexCollections';
import { getProductTypeFromTypename } from 'bundles/collections-carousel/constants';
import type { CarouselCollection, CollectionEntity } from 'bundles/collections-carousel/types/CarouselCollection';

export function toCarouselCollection(collection: ComplexCollection): CarouselCollection {
  const entities: CollectionEntity[] =
    collection.entities?.elements
      ?.map((entity, index) => {
        if (entity?.__typename !== 'ProductCard_ProductCard') {
          return null;
        }

        if (!entity.id) {
          return null;
        }

        // Extract data from productTypeAttributes
        const canonical = entity.productTypeAttributes?.canonical;

        const toImageUrl = () => {
          if ('promoPhotoUrl' in canonical) {
            return canonical.promoPhotoUrl ?? undefined;
          }
          if ('cardImageUrl' in canonical) {
            return canonical.cardImageUrl ?? undefined;
          }
          return undefined;
        };

        const isPathWaysContent = () => {
          switch (entity.productTypeAttributes.__typename) {
            case 'ProductCard_Course':
            case 'ProductCard_Specialization':
              return entity.productTypeAttributes.isPathwayContent ?? false;
            default:
              return false;
          }
        };

        // Handle different canonical types
        const name = canonical?.name ?? '';
        const slug = 'slug' in canonical ? canonical.slug : '';
        const link = 'urlPath' in canonical ? canonical.urlPath : '';
        const imageUrl = toImageUrl() ?? '';
        const partners = ('partners' in canonical ? canonical.partners : []) ?? [];
        const productType =
          'marketingProductType' in entity && typeof entity.marketingProductType === 'string'
            ? getProductTypeFromTypename(entity.marketingProductType)
            : undefined;
        return {
          id: entity.id,
          name,
          slug: slug || '',
          imageUrl,
          link: link || (slug ? `/learn/${slug}` : ''),
          partnerLogos: partners.map((partner) => partner.squareLogo ?? ''),
          partners:
            partners.map((partner) => ({
              id: partner.id,
              logo: partner.squareLogo ?? '',
              name: partner.name ?? '',
            })) || [],
          productType,
          isPathwayContent: isPathWaysContent(),
          trackingData: {
            entityId: entity.id,
            entityIndex: index,
            name,
            slug: slug ?? '',
            id: entity.id,
          },
          context: collection.context,
          recommenderConfigurationHash: collection.recommenderConfigurationHash ?? undefined,
        } satisfies CollectionEntity;
      })
      .filter(Boolean) || [];

  return {
    collectionId: collection.id,
    title: collection.description ?? '',
    entities,
    recommender: {
      hash: collection.recommenderConfigurationHash ?? '',
    },
    collectionTrackingData: {
      collectionId: collection.id,
      collectionName: collection.description,
    },
  };
}
